$(document).ready(function(){
    /**
     * Default owl.carousel init
     */
    $('.owl-carousel.js-single-carousel').owlCarousel({
        autoplay: false,
        loop: false,
        dots: false,
        nav: false,
        items: 1,
    });

    var carousel = $('.owl-carousel.js-car-carousel').owlCarousel({
        autoplay: false,
        loop: true,
        dots: false,
        nav: false,
        responsive:{
            0:{
                items:1,
                dots: true,
                loop: true,
            },
            576:{
                items:4,
                loop: false
            }
        },
        lazyLoad: true
    });

    $('.js-slide-prev').on('click', function() {
        carousel.trigger('prev.owl.carousel');
    });

    $('.js-slide-next').on('click', function() {
        carousel.trigger('next.owl.carousel');
    });
});



// WEBPACK FOOTER //
// ./scripts/plugins/owl.carousel.js